var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import get from "lodash/get";
import find from "lodash/find";
import { CartItem } from "./CartItem";
import { getUniqueCartItemId } from "../helpers";
import { dateObjectOrNull } from "../../helpers/date";
var RootCartItem = /** @class */ (function (_super) {
    __extends(RootCartItem, _super);
    function RootCartItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isRoot = true;
        return _this;
    }
    Object.defineProperty(RootCartItem.prototype, "priceId", {
        get: function () {
            var _a, _b, _c, _d, _e;
            if (!this.timespan) {
                return String(((_a = this.priceModel) === null || _a === void 0 ? void 0 : _a.id) || "");
            }
            if (!((_b = this.timespan) === null || _b === void 0 ? void 0 : _b.hasStepPricing)) {
                return String(((_c = this.priceModel) === null || _c === void 0 ? void 0 : _c.id) || "");
            }
            var maxQuantity = this.timespan.deriveQuantityLeft({ selectedSlot: this.bookingSlot }) || 0;
            var pc = this.timespan.getAvailablePrices({ quantity: this.quantity, maxQuantity: maxQuantity });
            return String(((_e = pc.findById((_d = this.priceModel) === null || _d === void 0 ? void 0 : _d.id)) === null || _e === void 0 ? void 0 : _e.id) || "");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootCartItem.prototype, "onDate", {
        get: function () {
            var _a;
            return (_a = this.dirtyCartItem) === null || _a === void 0 ? void 0 : _a.onDate;
        },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(RootCartItem.prototype, "uniqueParentId", {
        get: function () {
            return this.priceId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootCartItem.prototype, "bookingSlot", {
        get: function () {
            var _a;
            return (_a = this.dirtyCartItem) === null || _a === void 0 ? void 0 : _a.bookingSlot;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootCartItem.prototype, "_booking", {
        get: function () {
            var _a, _b;
            return {
                to: dateObjectOrNull((_a = this.bookingSlot) === null || _a === void 0 ? void 0 : _a.to) || undefined,
                from: dateObjectOrNull((_b = this.bookingSlot) === null || _b === void 0 ? void 0 : _b.from) || undefined,
                course_timespan_id: this.timespanId,
                quantity: this.quantity,
                personal_data_index: this.personalDataIndex
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootCartItem.prototype, "toWaitList", {
        get: function () {
            return !!this.timespan
                && this.timespan.isNonBindingWaitingList
                && this.timespan.waitingListCount > 0
                && this.quantity > this.timespan.maxBookablePlacesLeftForReal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootCartItem.prototype, "dirtyCartItem", {
        get: function () {
            var _a;
            var key = getUniqueCartItemId((_a = this.priceModel) === null || _a === void 0 ? void 0 : _a.id, this.parentPriceId, this.timespanId, this.props.bookingSlot);
            return get(this.props.dirtyValues, key);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootCartItem.prototype, "quantity", {
        get: function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
            if ((_a = this.timespan) === null || _a === void 0 ? void 0 : _a.hasStepPricing) {
                // Check dirty value in steps
                // If exists, take dirty value; else drop value
                // If no value take first value from the step range.
                var selectedQuantity_1 = (_c = (_b = this.dirtyCartItem) === null || _b === void 0 ? void 0 : _b.position) === null || _c === void 0 ? void 0 : _c.quantity;
                var stepRange = (_d = this.timespan) === null || _d === void 0 ? void 0 : _d.deriveStepsRange({ bookingSlot: (_e = this.dirtyCartItem) === null || _e === void 0 ? void 0 : _e.bookingSlot });
                if (!selectedQuantity_1) {
                    return stepRange.length === 1 ? (_g = (_f = stepRange[0]) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : "" : "";
                }
                var sanitizedValue = (_h = find(stepRange, function (_a) {
                    var value = _a.value;
                    return value === String(selectedQuantity_1);
                })) === null || _h === void 0 ? void 0 : _h.value;
                return String(sanitizedValue !== null && sanitizedValue !== void 0 ? sanitizedValue : (_j = stepRange[0]) === null || _j === void 0 ? void 0 : _j.value);
            }
            // Selected Slot should be null here
            // If the selected slot is passed down, the quantity becomes dependent on the booking slot.
            var maxQuantity = ((_k = this.timespan) === null || _k === void 0 ? void 0 : _k.deriveQuantityLeft({})) || 0;
            var fallbackValue = 1;
            var selectedQuantity = +(((_o = (_m = (_l = this.dirtyCartItem) === null || _l === void 0 ? void 0 : _l.position) === null || _m === void 0 ? void 0 : _m.quantity) !== null && _o !== void 0 ? _o : (_q = (_p = this.dirtyCartItem) === null || _p === void 0 ? void 0 : _p.booking) === null || _q === void 0 ? void 0 : _q.quantity) || "");
            selectedQuantity = +selectedQuantity || fallbackValue;
            selectedQuantity = Math.min(selectedQuantity, maxQuantity);
            return String(selectedQuantity);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootCartItem.prototype, "participantCount", {
        get: function () {
            var _a, _b;
            if ((_a = this.timespan) === null || _a === void 0 ? void 0 : _a.shouldTakeOnlyOneParticipant) {
                return 1;
            }
            if (!((_b = this.timespan) === null || _b === void 0 ? void 0 : _b.shouldCollectParticipantInformation)) {
                return 1;
            }
            return Number(this.quantity);
        },
        enumerable: false,
        configurable: true
    });
    return RootCartItem;
}(CartItem));
export { RootCartItem };
